import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';
// Single source of truth for the brand colour lives in the SCSS token file; its
// `:export` block makes the values readable from TS.
import variables from './_variables.module.scss';

export const AppPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: variables.primary,
          inverseColor: variables.primary,
          hoverColor: variables.primary,
          activeColor: variables.primary
        },
        highlight: {
          background: variables.primaryHighlight,
          focusBackground: variables.primaryHighlightFocus,
          color: '{primary.color}',
          focusColor: '#ffffff'
        },
        formField: {
          hoverBorderColor: '{primary.color}'
        }
      }
    }
  },
  directives: {
    // One white tooltip, app-wide (ENG-9906, D1): `v-tooltip` takes the look of a field's help, which is a Popover, read
    // from the popover's own tokens so the two can't come apart. Under `directives`, as Aura keeps it: PrimeVue never
    // reads a `components.tooltip`. The thin border and its arrow have no tooltip token, so `tooltip.scss` draws them,
    // and the gutter is the room for that arrow between the trigger and the text.
    tooltip: {
      root: {
        gutter: 'var(--ts-space-2)',
        shadow: '{overlay.popover.shadow}',
        padding: '{overlay.popover.padding}',
        borderRadius: '{overlay.popover.border.radius}'
      },
      colorScheme: {
        light: {
          root: {
            background: '{overlay.popover.background}',
            color: '{overlay.popover.color}'
          }
        }
      }
    }
  }
});
